import script from "./PurchaseRentPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./PurchaseRentPlan.vue?vue&type=script&setup=true&lang=js"

import "./PurchaseRentPlan.vue?vue&type=style&index=0&id=64e7e1ba&lang=scss"

const __exports__ = script;

export default __exports__